import { jsx as _jsx } from "react/jsx-runtime";
export function Table({ children, className = "", }) {
    return (_jsx("div", { className: "w-full overflow-auto", children: _jsx("table", { className: ["w-full caption-bottom text-sm", className].join(" "), children: children }) }));
}
export function TableHeader({ children, className = "", }) {
    return _jsx("thead", { className: className, children: children });
}
export function TableBody({ children, className = "", }) {
    return _jsx("tbody", { className: className, children: children });
}
export function TableRow({ children, className = "", }) {
    return (_jsx("tr", { className: [
            "border-b border-[var(--color-border)] transition-colors hover:bg-[var(--color-muted)]",
            className,
        ].join(" "), children: children }));
}
export function TableHead({ children, className = "", }) {
    return (_jsx("th", { className: [
            "h-10 px-4 text-left align-middle font-medium text-[var(--color-muted-foreground)]",
            className,
        ].join(" "), children: children }));
}
export function TableCell({ children, className = "", colSpan, }) {
    return (_jsx("td", { className: ["p-4 align-middle", className].join(" "), colSpan: colSpan, children: children }));
}
